import { useEffect, useState } from "react";
import { ShieldAlert, X } from "lucide-react";

const KEY = "spi-disclosure-ack";

export default function DisclosureBanner() {
  const [dismissed, setDismissed] = useState(true); // hide until effect runs

  useEffect(() => {
    if (typeof window === "undefined") return;
    setDismissed(localStorage.getItem(KEY) === "1");
  }, []);

  if (dismissed) return null;

  const accept = () => {
    localStorage.setItem(KEY, "1");
    setDismissed(true);
  };

  return (
    <div
      role="region"
      aria-label="Information service privé"
      data-testid="disclosure-banner"
      className="bg-spi-blue text-white border-t border-spi-red/40"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-12 py-3 flex items-center gap-3">
        <ShieldAlert className="w-5 h-5 text-spi-red flex-shrink-0" strokeWidth={1.75} />
        <p className="flex-1 text-xs md:text-[13px] leading-relaxed text-slate-100">
          <span className="font-bold uppercase tracking-wide text-[11px]">
            Swiss Premium Insurance
          </span>
        </p>
        <button
          onClick={accept}
          aria-label="Fermer le bandeau"
          data-testid="disclosure-dismiss"
          className="p-1.5 hover:bg-white/10 rounded transition-colors flex-shrink-0"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
